import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import StepConnector from '@material-ui/core/StepConnector';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CompareIcon from '@material-ui/icons/Compare';
import Button from "@material-ui/core/Button";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import IconButton from "@material-ui/core/IconButton";


const TextOnlyTooltip = withStyles({
    tooltip: {
        color: "white",
        backgroundColor: "#ff9800",
        fontSize: "1em"
    }
})(Tooltip);

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: '#784af4',
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#784af4',
        zIndex: 1,
        fontSize: 18,
    },
    buttonStepper:{
        margin:50,
    },
    });

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
}

QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundImage:
                'linear-gradient(90deg, rgba(4,20,5,1) 0%, rgba(26,109,28,1) 50%, rgba(56,219,22,1) 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                'linear-gradient(90deg, rgba(4,20,5,1) 0%, rgba(26,109,28,1) 50%, rgba(56,219,22,1) 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
    buttonStepper:{
        margin:50,
        textAlign:"center"
    }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundImage:
            'linear-gradient(90deg, rgba(4,20,5,1) 0%, rgba(26,109,28,1) 50%, rgba(56,219,22,1) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundImage:
            'linear-gradient(90deg, rgba(4,20,5,1) 0%, rgba(26,109,28,1) 50%, rgba(56,219,22,1) 100%)',
    },
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
        1: <TouchAppIcon/>,
        2: <AssessmentIcon />,
        3: <CompareIcon />,
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));


export default function CustomizedSteppers(props) {

    const classes = useStyles();
    const [activeStep] = React.useState(props.initialValue);
    const [helpTool, setHelpTool] = useState(true);
    const steps = [props.language.labels[props.language.id].stepper1,props.language.labels[props.language.id].stepper2 , props.language.labels[props.language.id].stepper3];
    function clickNext(){
        if(props.initialValue===0) {
            if (props.dataset === undefined || props.dataset === "") {
                props.handleGlobalMessage(
                    "error",
                    "You have to select one dataset"
                );
            } else {
                console.log(props.nameNewDataset)
                if(props.dataset ==="new"){
                    props.handleDatasetNewNameBeginner(props.nameNewDataset, props.file)
                }else if(props.dataset === "newScratch"){
                    props.handleDatasetNewNameScratch(props.nameNewDataset, props.fileScratch)
                }else {
                    props.handleDataset(props.dataset.name)
                }
            }
        }else if(props.initialValue===1){
            props.gotoComparation()
        }else if(props.initialValue ===2){
            props.compareExplanations()
        }
    }
    function clickBack(){
        if(props.initialValue===0) {

        }else if(props.initialValue===1){
            props.goToInitial()
        }else if(props.initialValue ===2){
           if(props.lastStep === true){
               props.goBackSelectAlgorithms()
           }else{
               props.goBackGeneralInformation();
           }
        }
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            setHelpTool(false);
        }, 4000);
        return () => clearTimeout(timer);
    });
    function clickHelpIcon() {
        setHelpTool(!helpTool);
    }
    return (
        <div className={classes.root}>
            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div style={{margin:50,textAlign:"center"}}>
                <Button
                    style={{width:"10%"}}
                    disabled={activeStep === 0}
                    className={classes.backButton}
                    onClick={clickBack}
                >
                    <ArrowBackIcon/>{" "}{props.language.labels[props.language.id].back}
                </Button>
                <TextOnlyTooltip title={
                    props.initialValue===0 ?
                        props.language.labels[props.language.id].help1
                        :props.initialValue===1 ?
                        props.language.labels[props.language.id].help2
                            : props.language.labels[props.language.id].help3
                } open={helpTool}>
                <Button disabled={props.lastStep} style={{color:"white",width:"10%"}} onClick={clickNext} variant="contained" color="primary" >
                    {props.initialValue === 2 ? props.language.labels[props.language.id].finish : props.language.labels[props.language.id].next}{" "}<ArrowForwardIcon/>
                </Button>
                </TextOnlyTooltip>
                <IconButton onClick={clickHelpIcon}>
                    <HelpIcon/>
                </IconButton>
            </div>

        </div>
    );
}
